/// <reference path="../../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    "use strict";

    import IncludedEmployeeEnum = Meevo.Model.IncludedEmployeeEnum;

    export class SmartTilePropIncludedEmployee implements angular.IComponentOptions {
        templateUrl = "app/components/controls/smartCenterDesigner/propertyViews/smartTilePropIncludedEmployee.component.html";
        bindings: any = {
            prop: '=?',
            selectionChanged: '&?',
            tile: '=?'
        }
        controller = class SmartTilePropIncludedEmployeeController {
            static $inject = [
                "meevo.components.common.DataService",
                "meevo.AppSettings"
            ];

            public prop: Meevo.Model.SmartTileParameter;
            public selectedItem: Model.EnumDto;
            public includedEmployees: Model.EnumDto[] = [];
            public selectionChanged: Function;
            public tile: Meevo.Model.SmartCenterSmartTile;
            public isEmployeeSelectorShown: boolean = false;
            public employeeCriteria: any = {
                showEmployeesOnly: true,
                includeSharedEmployee: true
            };
            public specificEmployee: Meevo.Model.EmployeeListItem = null;

            constructor(protected dataService: Components.BaseClasses.IDataService, protected appSettings: Meevo.Components.Common.IAppSettings) { }

            $onInit(): void {
                this.dataService.getEnumList(Model.EnumTypeEnum.IncludedEmployeeEnum).then(includedEmployees => {
                    this.includedEmployees = includedEmployees;
                    if (this.prop && this.prop.parameterValue) {
                        this.selectedItem = _.findWhere(this.includedEmployees, { value: this.prop.parameterValue });
                        this.onSelectionChanged();
                        this.checkAndLoadSelectedEmployee();                        
                    }
                });
            }

            onSelectionChanged(): void {
                this.prop.parameterValue = this.selectedItem.value;
                this.prop.parameterDisplayName = this.selectedItem.displayName;
                this.selectionChanged({ selection: this.selectedItem });
                if (this.selectedItem.id === IncludedEmployeeEnum.SpecificEmployee) {
                    this.isEmployeeSelectorShown = true;
                } else {
                    this.isEmployeeSelectorShown = false;
                    this.specificEmployee = null;
                    this.onSpecificEmployeeChanged();
                }
            }

            // Hydrates the specificEmployee selection from the saved employeeId in the tile parameters, if applicable
            // This is to populate the typeahead properly when editing an existing tile instance with an employee already chosen
            private checkAndLoadSelectedEmployee(): void {
                if (this.selectedItem.id === IncludedEmployeeEnum.SpecificEmployee) {
                    const employeeId = this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId] ? this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId].parameterValue : null;
                    if (employeeId) {
                        this.dataService.customMethodData(`${this.appSettings.API_ROOT}/employee/${employeeId}`, 'GET', null).then((res: any) => {
                            if (res.data) {
                                this.specificEmployee = {
                                    id: res.data.id,
                                    locationId: res.data.locationId,
                                    displayName: res.data.displayName,
                                    objectState: res.data.objectState,
                                    objectCreationType: res.data.objectCreationType,
                                    firstName: res.data.firstName,
                                    lastName: res.data.lastName,
                                    dateTerminated: res.data.dateTerminated,
                                    code: res.data.employeeCode,
                                    gender: res.data.gender,
                                    isBookableOnline: res.data.isBookableOnline,
                                    appointmentBookOrder: res.data.appointmentBookOrder,
                                    isEmployee: true,
                                    allowTips: res.data.allowTips,
                                    allowSales: res.data.allowSales,
                                    maskingIncrement: res.data.maskingIncrement,
                                    incrementMaskingText: res.data.incrementMaskingText,
                                    employeeCatId: res.data.employeeCategories[0].id,
                                    employeeEntityType: res.data.employeeEntityTypeEnum                                    
                                }
                            }
                        });
                    }
                }
            }

            public onSpecificEmployeeChanged(): void {
                this.updateSpecificEmployeeParameter(this.specificEmployee);
                // Emit selectionChanged so that tile title gets rebuilt
                this.selectionChanged({ selection: this.selectedItem });
            }

            private updateSpecificEmployeeParameter(employee: Meevo.Model.EmployeeListItem): void {
                const employeeId = employee ? employee.id : null;
                if (employeeId) {
                    if (this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId]) {
                        this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId].parameterValue = employeeId;
                        this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeCode].parameterValue = employee.code;
                    } else {
                        this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId] = {
                            label: 'Employee',
                            labelKey: 'CUSTOM_LABEL_EMPLOYEE',
                            parameterType: Meevo.Model.SmartTileParameterTypes.stringType,
                            isHidden: true,
                            parameterValue: employeeId
                        };
                        this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeCode] = {
                            label: 'EmployeeCode',
                            labelKey: '',
                            parameterType: Meevo.Model.SmartTileParameterTypes.stringType,
                            isHidden: true,
                            parameterValue: employee.code
                        };
                    }

                } else {
                    delete this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeId];
                    delete this.tile.parsedParameters[Meevo.Model.SmartTileParameterNames.employeeCode];
                }
            }
        }
    }

    angular.module("meevo.components.controls")
        .component("stpIncludedEmployee", new SmartTilePropIncludedEmployee());
}
